<template lang="pug">
.card-coupons-container(
  v-if="info"
  :class="{\
    card: info.isCard,\
    shadow: info.shadow,\
    'with-corner': info.corner,\
    'no-sku': info.status===COUPON_STATUS.NO_SKU \
  }",
  @click="click"
)
  template(v-if="!info.shadow")
    .corner.flex-mid(v-if="info.corner")
      span {{ info.corner }}
    .left-container
      .left.column(v-if="info.isCard")
        .price(:class="['length-' + info.currentPrice.length]")
          span.current {{ info.currentPrice || '-' }}
          span.unit 元
      .mid.column
        .title {{ info.title || '' }}
        template(v-if="!info.isCard")
          .subtitle {{ info.subtitle }}
        template(v-else)
          .subtitle(v-if="info.type !== 3")
            span.origin-price(v-if="info.originPrice") {{ info.originPrice }}元
            span.diff &nbsp;{{ info.diff }}
    .right.column
      .btn.flex-mid(@click="$emit('btn', info)") {{ btn }}
</template>

<script>
import { COUPON_STATUS } from '../../welfare/consts';

export default {
  props: {
    info: {
      type: Object,
      default: () => ({
        title: '单车骑行卡·30天不限次单车骑行卡·30天不限次',
        subtitle: '乘客确认到达可到账',
        originPrice: '20',
        diff: '平台补4.2元',
        isCard: false,
        // corner: 'APP专享',
        currentPrice: '5',
        shadow: false,
      }),
    },
  },
  data() {
    return {
      COUPON_STATUS,
    };
  },
  computed: {
    btn() {
      return this.info.btn || '购买';
    },
  },
  methods: {
    click() {
      this.$emit('click', this.info);
    },
  },
};
</script>

<style lang="less" scoped>
.mixin-btn-border() {
  width: 0.68rem;
  height: 0.25rem;
  border-radius: 0.13rem;
  border: 1px solid #ff6011;
  color: #ff5526;
  background: inherit;
}

.card-coupons-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 0.75rem;
  border-radius: 0.08rem;
  box-sizing: border-box;
  background-size: 100% 100%;
  background-image: url("https://m.hellobike.com/resource/AppPlatformH5/base-success/qAZC6oFaIbrHoNiadWqIz.png");

  &.shadow {
    width: 100%;
    height: 0.71rem;
    background: #f7f9fa;
    border-radius: 0.04rem;

    &:not(:last-of-type) {
      margin-bottom: 0.08rem;
    }
  }

  .column {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .left {
    width: 0.8rem;
    padding-right: 0.08rem;
    box-sizing: border-box;
  }

  &.with-corner {
    .left {
      padding-top: 0.08rem;
    }
  }

  .mid {
    flex: 1;
    max-width: 1.65rem;
    align-items: flex-start;
    justify-content: center;
    white-space: nowrap;
  }

  .right {
    padding-right: 0.16rem;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .btn {
    width: 0.62rem;
    height: 0.25rem;
    border-radius: 0.13rem;
    font-size: 0.12rem;
    font-weight: 500;
    border: 0.01rem solid #ff522a;
    color: #ff562f;
  }

  &.no-sku {
    .btn {
      background: #f4b797;
      border: none;
      color: white;
    }
  }

  .title {
    font-size: 0.16rem;
    font-weight: 500;
    color: #242729;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: keep-all;
    word-wrap: normal;
    margin-bottom: 0.1rem;
    max-width: 2rem;
  }

  .price {
    font-size: 0.3rem;

    .current {
      font-size: 0.3rem;
      font-weight: bold;
      font-family: "DIN Alternate Bold", sans-serif;
      color: #845529;
      line-height: 1;
      position: relative;
      top: 0.02rem;
      white-space: nowrap;
    }

    > .unit {
      font-size: 0.12rem;
      font-weight: 600;
      color: #845529;
    }

    &.length-2 {
      .current {
        font-size: 0.3rem;
      }

      .unit {
        font-size: 0.12rem;
      }
    }

    &.length-3 {
      .current {
        font-size: 0.3rem;
      }

      .unit {
        font-size: 0.124rem;
      }
    }

    &.length-4 {
      .current {
        font-size: 0.26rem;
      }

      .unit {
        font-size: 0.12rem;
      }
    }

    &.length-5 {
      .current {
        font-size: 0.2rem;
      }

      .unit {
        font-size: 0.12rem;
      }
    }

    &.length-6 {
      .current {
        font-size: 0.18rem;
      }

      .unit {
        font-size: 0.12rem;
      }
    }
  }

  .subtitle {
    display: flex;
    font-weight: 600;
    font-size: 0.12rem;
    color: #5a6066;
    max-width: 1.65rem;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: keep-all;
    word-wrap: normal;

    .diff {
      max-width: 1.3rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .direct-use {
    display: flex;
    margin-top: 0.07rem;
    font-size: 0.12rem;
    font-weight: 600;
    color: #ff6940;

    .common-arrow-right {
      border-color: #ff6940;
      margin-left: -3px;
    }
  }

  .process {
    display: flex;
    align-items: center;
    margin-top: 0.12rem;

    .line {
      position: relative;
      width: 0.74rem;
      height: 0.05rem;
      border-radius: 0.04rem;
      background: #f6c9ac;
    }

    .colored {
      position: absolute;
      left: 0;
      top: 0;
      height: 0.05rem;
      background: linear-gradient(137deg, #ff8e67 0%, #ff5103 100%);
      border-radius: 0.04rem;
    }

    .status {
      margin-left: 0.05rem;
      font-size: 0.1rem;
      font-weight: 500;
      color: #ed7043;
    }
  }

  .origin-price {
    color: #b5876f;
    text-decoration: line-through;
  }

  .corner {
    position: absolute;
    top: 0;
    left: 0;
    height: 0.15rem;
    background: #ec5e40;
    border-radius: 0.08rem 0 0.08rem 0;
    font-size: 10px;
    line-height: 1;
    padding: 0.01rem 0.06rem;
    color: rgba(255, 255, 255, 1);

    span {
      display: inline-block;
      transform: scale(1.1);
      transform-origin: center center;
    }
  }

  .left-container {
    display: flex;
    align-items: center;
    flex: 1;
    height: 100%;
    padding-left: 0.1rem;
  }

  &.card {
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/base-success/AfFDZoLCR62q4ExwXCc6m.png);

    .title {
      font-size: 0.14rem;
      font-weight: 500;
      color: #7c3d09;
      max-width: 1.65rem;
    }

    .left-container {
      padding-left: 0;
    }

    .subtitle {
      color: #deb160;

      .origin-price {
        color: #deb160;
      }
    }

    .btn {
      background: linear-gradient(270deg, #fc4e00 0%, #ff7906 100%);
      border: none;
      color: #fff;
    }
  }

  .with-corner {
    .left-container .left {
      padding-top: 0.04rem;
    }
  }
}
</style>
